var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var EmailToScheduleBusiness = function (storeContainer) {
    var store = storeContainer.store;
    var emailToScheduleStore = store.emailToScheduleStore, commonStore = store.commonStore;
    var propsConnect = {
        currentWOIndex: emailToScheduleStore.currentWOIndex,
        selectedSchedule: emailToScheduleStore.selectedSchedule,
        isRecommendLoading: emailToScheduleStore.isRecommendLoading,
        isPageLoading: emailToScheduleStore.isPageLoading,
        scheduleRecommonedList: emailToScheduleStore.scheduleRecommonedList,
        noRecommonedChecked: emailToScheduleStore.noRecommonedChecked,
        woList: emailToScheduleStore.woList,
        pendingWoList: emailToScheduleStore.pendingWoList,
        scheduleTimeBlocks: emailToScheduleStore.scheduleTimeBlocks,
        isShowMessage: emailToScheduleStore.isShowMessage,
        isNoRecommend: emailToScheduleStore.isNoRecommend,
        allPendingScheduleAndScheduleWoList: emailToScheduleStore.allPendingScheduleAndScheduleWoList,
        allScheduleWoList: emailToScheduleStore.allScheduleWoList,
        displayCurrentIndex: emailToScheduleStore.displayCurrentIndex,
        displayTotal: emailToScheduleStore.displayTotal,
        isExistVisit: emailToScheduleStore.isExistVisit,
        isEgentWo: emailToScheduleStore.isEgentWo,
        isScheduleSuccess: emailToScheduleStore.isScheduleSuccess,
        copilotLink: emailToScheduleStore.copilotLink,
        currentUser: commonStore.currentUser,
    };
    var dispatchConnect = {
        getCopilotLink: function () { return emailToScheduleStore.getCopilotLink(); },
        setSelectedSchedule: function (schedule) { return emailToScheduleStore.setSelectedSchedule(schedule); },
        getWeatherByTime: function (date) { return emailToScheduleStore.getWeatherByTime(date); },
        getWOList: function () { return emailToScheduleStore.getWOList(); },
        getWoRecommendTechnicians: function () { return emailToScheduleStore.getWoRecommendTechnicians(); },
        schedule: function (wo) { return emailToScheduleStore.schedule(wo); },
        set: emailToScheduleStore.set,
        resendEmail: emailToScheduleStore.resendEmail,
        getCurrentUser: function () { return commonStore.getCurrentUser(); }
    };
    return __assign(__assign({}, propsConnect), dispatchConnect);
};
